function Panels() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="1" y="1" width="22" height="22" />

      <line x1="1" y1="8" x2="23" y2="8" />
      <line x1="1" y1="15" x2="23" y2="15" />

      <line x1="9" y1="1" x2="9" y2="8" />
      <line x1="16" y1="1" x2="16" y2="8" />

      <line x1="4.5" y1="8" x2="4.5" y2="15" />
      <line x1="12.5" y1="8" x2="12.5" y2="15" />
      <line x1="19.5" y1="8" x2="19.5" y2="15" />

      <line x1="9" y1="15" x2="9" y2="23" />
      <line x1="16" y1="15" x2="16" y2="23" />
    </svg>
  );
}

export default Panels;
